import commonService from './commonService';
import config from '../config';

const impaCategoryMasterServices = {
    getAllIMPACategories,
    saveUpdateDeleteMasterInfo,
    editMasterById,
    getAllActiveMasterList,
    getAllCurrencyList,
}

function getAllIMPACategories(payload,transactionId,moduleId){
    return commonService.restCall({
    url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
      method:'POST',
      headers:[
            { moduleId: moduleId ? moduleId : 1 },
            { transactionId: transactionId },
            { CategoryId: 0 },
        ],
        data:payload
    });
};

function getAllActiveMasterList(payload,transactionId){
    return commonService.restCall({
    url:`${config.apiUrl}${config.snapshot.getAllActiveMasters}`,
      method:'POST',
      headers:[
            { moduleId: 1 },
            { transactionId: transactionId },
            { CategoryId: 0 },
        ],
        data:payload
    });
};


function saveUpdateDeleteMasterInfo(payload,transactionId){

    return commonService.restCall({
        url: `${config.apiUrl}${config.snapshot.saveUpdateDeleteMasterInfo}`,
        method: 'POST',
        headers:[
            { moduleId: 1 },
            { transactionId: transactionId},
            { CategoryId: 0 },
        ],
        data:payload
    })
};

function editMasterById(payload, transactionId){

    return commonService.restCall({
        url: `${config.apiUrl}${config.snapshot.getMasterRecord}`,
        method: "POST",
        data:payload,
        headers:[
            { moduleId: 1 },
            { transactionId: transactionId },
            { CategoryId: 1 },
        ],
    })
};

function getAllCurrencyList(payload,transactionId){
    let data = [];
    return commonService.restCall({
        url: `${config.apiUrl}${config.snapshot.currencyList}`,
        method: "GET",
        headers: [
          { moduleId: 31 },
          { transactionId: 1 },
          { CategoryId: "0" },
        ],
    });
};

export default impaCategoryMasterServices;